module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com"
  }, [_c('iframe', {
    staticClass: "frame",
    attrs: {
      "src": _vm.src,
      "frameborder": "0",
      "id": "iframe"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-054e1fb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/scoreManage/setting/tempExemptStudy.vue
// module id = 1768
// module chunks = 502